import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="d-sm-flex justify-content-center">
          <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">
            Copyright © {new Date().getFullYear()} Sarees Bazaar. Website
            developed By:{" "}
            <Link
              target="_blank"
              className="text-gray hover-white"
              to="https://www.setblue.com/"
              title="+91 98985 98984"
            >
              Setblue.com
            </Link>
          </span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
